import axios from "axios";
import APS_URL from "../APS_URL";
import { toast } from "react-toastify";
import * as c from "../constants";

export const postAddItem = async (str, closeModal, setProcessAddStatus) => {
  try {
    const res = await axios.post(APS_URL + "/postAddItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: str,
    });
    if (res.status === 200) {
      toast.success("제품이 추가되었습니다.");
      closeModal();
      setProcessAddStatus(true);
    }
  } catch (e) {
    console.log(e);
    closeModal();
    setProcessAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const postAddProcess = async (
  arr,
  mchList,
  selectedMchName,
  closeModal,
  setProcessAddStatus,
  sum
) => {
  try {
    let finalArray = [arr].map((item) => {
      return { ...item, proc_time: sum };
    });
    for (let i = 0; i < selectedMchName.length; i++) {
      finalArray[0].proc_mch.push(
        mchList.filter((item) => item.mch_name === selectedMchName[i])[0].mch_id
      );
    }
    const res = await axios.post(APS_URL + "/postAddProcess", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: finalArray[0],
    });
    if (res.status === 200) {
      toast.success("공정이 추가되었습니다.");
      closeModal();
      setProcessAddStatus(true);
    }
  } catch (e) {
    console.log(e);
    closeModal();
    setProcessAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const postAddMachine = async (
  inputValue,
  closeModal,
  num,
  setMachineAddStatus,
  workPlaceIdArray
) => {
  try {
    const res = await axios.post(APS_URL + "/postAddMachine", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: [inputValue.mch_name, num, workPlaceIdArray],
    });
    if (res.status === 200) {
      toast.success("장비가 추가되었습니다.");
      setMachineAddStatus(true);
      closeModal();
    }
  } catch (e) {
    console.log(e);
    closeModal();
    setMachineAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const deleteMachine = async (mch_Id, setMachineAddStatus) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL + `/deleteMachineData?data=${mch_Id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success("장비 정보를 삭제하였습니다.");
        setMachineAddStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setMachineAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const putProcessDetail = async (
  arr,
  closeModal,
  setProcessAddStatus
) => {
  try {
    if (window.confirm("수정하시겠습니까?")) {
      const res = await axios.put(APS_URL + "/putInsightwinProcessDetail", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: arr,
      });
      if (res.status === 200) {
        toast.success("성공적으로 수정되었습니다.");
        closeModal();
        setProcessAddStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setProcessAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const deleteProcessDetail = async (
  currProc,
  closeModal,
  setProcessAddStatus
) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL +
          `/deleteProcessDetail?data=${currProc.item_id}@${currProc.proc_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success("공정을 삭제하였습니다.");
        closeModal();
        setProcessAddStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setProcessAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const deleteMachineData = async (
  mch_id,
  closeModal,
  setMachineAddStatus
) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL + `/deleteMachineData?data=${mch_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success("장비 정보를 성공적으로 삭제하였습니다.");
        setMachineAddStatus(true);
        closeModal();
      }
    }
  } catch (e) {
    console.log(e);
    setMachineAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const postProcessAdd = async (
  item,
  startDate,
  input,
  closeModal,
  setUpdateStatus
) => {
  try {
    if (!item || startDate.startsWith("NaN") || !input || !startDate) {
      toast.error("칸을 잘 채웠는지 확인해주세요.");
    } else {
      const res = await axios.post(APS_URL + "/postInsightwinProcessAdd", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: [item, startDate, input],
      });
      if (res.status === 200) {
        toast.success("주문이 추가되었습니다.");
        closeModal();
        setUpdateStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const putMachineEdit = async (arr, closeModal, setMachineAddStatus) => {
  try {
    if (window.confirm("수정하시겠습니까?")) {
      const res = await axios.put(
        APS_URL + "/putInsightwinPlannerMachineData",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: arr,
        }
      );
      if (res.status === 200) {
        toast.success("성공적으로 수정되었습니다.");
        closeModal();
        setMachineAddStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setMachineAddStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const putOrderEdit = async (arr, closeModal, setStatus) => {
  try {
    if (window.confirm("수정하시겠습니까?")) {
      const res = await axios.put(
        APS_URL + "/putInsightwinPlannerOrderData",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
        },
        body: arr,
      });
      if (res.status === 200) {
        toast.success("성공적으로 수정되었습니다.");
        closeModal();
        setStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const putWorkplaceEdit = async (
  arr,
  id,
  closeModal,
  setWorkplaceUpdateStatus
) => {
  try {
    if (window.confirm("수정하시겠습니까?")) {
      const res = await axios.put(APS_URL + "/putWorkplaceEdit", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: [...arr, id],
      });
      if (res.status === 200) {
        toast.success("성공적으로 수정되었습니다.");
        closeModal();
        setWorkplaceUpdateStatus(true);
      }
    }
  } catch (e) {
    console.log(e);
    setWorkplaceUpdateStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const postWorkPlaceAdd = async (
  str,
  setWorkplaceUpdateStatus,
  closeModal
) => {
  try {
    const res = await axios.post(APS_URL + "/postWorkPlaceAdd", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: [str],
    });
    if (res.status === 200) {
      toast.success("성공적으로 추가되었습니다.");
      closeModal();
      setWorkplaceUpdateStatus(true);
    }
  } catch (e) {
    setWorkplaceUpdateStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const deleteWorkplace = async (
  workplace_id,
  closeModal,
  setWorkplaceUpdateStatus
) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL + `/deleteWorkplaceData?data=${workplace_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success("작업장 정보를 성공적으로 삭제하였습니다.");
        setWorkplaceUpdateStatus(true);
        closeModal();
      }
    }
  } catch (e) {
    console.log(e);
    setWorkplaceUpdateStatus(false);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
  }
};

export const deleteItemData = async (id, closeModal, setStatus) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL + `/deleteInsightwinOrderData?data=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success("제품 정보를 성공적으로 삭제하였습니다.");
        setStatus(true);
        closeModal();
      }
    }
  } catch (e) {
    console.log(e);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
    setStatus(false);
  }
};

export const putItemData = async (arr, closeModal, setStatus) => {
  try {
    if (window.confirm("수정하시겠습니까?")) {
      const res = await axios.put(
        APS_URL + "/putInsightwinPlannerItemData",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
        },
        body: arr,
      });
      if (res.status === 200) {
        toast.success("제품 정보를 성공적으로 수정하였습니다..");
        setStatus(true);
        closeModal();
      }
    }
  } catch (e) {
    console.log(e);
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
    setStatus(false);
  }
};

export const putSaveMainOrder = async (arr, setStatus, setSaveStack) => {
  try {
    if (window.confirm("저장하시겠습니까?")) {
      const res = await axios.put(APS_URL + "/putSaveMainOrder", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: arr,
      });
      if (res.status === 200) {
        toast.success("성공적으로 저장하였습니다.");
        setStatus(true);
        setSaveStack(1);
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export const deleteMainOrder = async (id, closeModal, setStatus) => {
  try {
    if (window.confirm("삭제하시겠습니까? 이 작업은 취소할 수 없습니다.")) {
      const res = await axios.delete(
        APS_URL + `/deleteMainOrder?data=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
        },
      });
      if (res.status === 200) {
        toast.success("제품 정보를 성공적으로 삭제하였습니다.");
        setStatus(true);
        closeModal();
      }
    }
  } catch (e) {
    toast.error("오류가 발생했습니다. 관리자에게 문의 바랍니다.");
    setStatus(false);
    console.log(e);
  }
};

export const putTaskEdit = async (arr, username) => {
  try {
    await axios.put(`${APS_URL}/putTaskEdit`, arr, {
      headers: {
        // "Content-Type": "application/json",
      },
      params: {
        username: username,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const postResetTask = async (username, setUpdateStatus) => {
  try {
    const res = await axios.post(APS_URL + "/plan/reset", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: { user: username },
    });
    if (res.status === 200) {
      setUpdateStatus(true);
    }
  } catch (e) {
    console.log(e);
    setUpdateStatus(true);
  }
};

export const postScheduleGanttAdd = async (
  arr,
  queryClient,
  setLoading,
  setNextUpdateStatus,
  nextUpdateStatus,
  messageStatusNumber
) => {
  try {
    setLoading(true);
    const res = await axios.post(APS_URL + "/postScheduleGantt", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: arr,
    });
    if (res.status === 200) {
      queryClient.invalidateQueries("tableData");
      setLoading(false);
      if (messageStatusNumber) {
        toast.success(c.successReset);
      } else {
        toast.success(c.successCreateData);
      }
      setNextUpdateStatus(!nextUpdateStatus);
    }
  } catch (e) {
    console.log(e);
    setLoading(false);
    setNextUpdateStatus(!nextUpdateStatus);
  }
};

export const deleteInsightwinOrderDataComplete = async (
  id,
  queryClient,
  setLoading,
  messageStatusNumber
) => {
  try {
    setLoading(true);
    if (!messageStatusNumber) {
      const res = await axios.delete(
        APS_URL + `/deleteInsightwinOrderDataComplete?data=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        queryClient.invalidateQueries("tableData");
        setLoading(false);
      }
    }
    if (messageStatusNumber && window.confirm(c.completeWarning)) {
      const res = await axios.delete(
        APS_URL + `/deleteInsightwinOrderDataComplete?data=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        toast.success(c.successComplete);
        queryClient.invalidateQueries("tableData");
        setLoading(false);
      }
    }
  } catch (e) {
    console.log(e);
    setLoading(false);
  } finally {
    setLoading(false);
  }
};

export const deleteInsightwinOrderDataCompleteForInformation = async (arr) => {
  try {
    await axios.delete(
      APS_URL + `/deleteInsightwinOrderDataCompleteForInformation?data=${arr}`
    );
  } catch (e) {
    console.log(e);
  }
};

export const putInsightwinPlannerMachineData = async (arr, setUpdateStatus) => {
  try {
    const res = await axios.put(
      APS_URL + "/putInsightwinPlannerMachineData",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
      },
      body: arr,
    });
    if (res.status === 200) {
      toast.success("장비명 수정 성공");
      setUpdateStatus(true);
    }
  } catch (e) {
    console.log(e);
    toast.error(e);
  }
};

export const postInsightwinMachineMaster = async (
  mch_name,
  setUpdateStatus
) => {
  try {
    const res = await axios.post(
      APS_URL + "/postInsightwinMachineMaster",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
      },
      body: mch_name,
    });
    if (res.status === 200) {
      toast.success("장비 추가 성공");
      setUpdateStatus(true);
    }
  } catch (e) {
    console.log(e);
    toast.error(e);
  }
};
